import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  currentViewIndex: 0
};

const baseWizardSlice = createSlice({
  name: 'baseWizard',
  initialState,
  reducers: {
    handleViewChange: (state, {payload}) => ({ ...state, currentViewIndex: payload }),
    handleNextView: state => ({ ...state, currentViewIndex: state.currentViewIndex + 1 }),
    handlePreviousView: state => ({ ...state, currentViewIndex: state.currentViewIndex - 1 })
  }
});
const { actions, reducer } = baseWizardSlice;
export default reducer;
export const {
  handleViewChange,
  handleNextView,
  handlePreviousView
} = actions;
